import React, { Component } from 'react';
import { Box, Card, Typography } from '@material-ui/core';

class CardButton extends Component {
    state = {  }
    render() {
        const { icon, title, action, disabled } = this.props;
        let style = {
            height: "100px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            cursor: disabled ? "no-drop" : "pointer",
            
        }
        return (
            <Box p={1}>
                <Card style={style} onClick={action }>
                    <Box>{icon}</Box>
                    <Typography variant="button">{title}</Typography>
                </Card>
            </Box>
        );
    }
}

export default CardButton;

{/* <div className="card card-button"
    onClick={() => this.state.form === "updateFORMS" ?
        this.setState({form: ""}) : 
        this.setState({form: "updateFORMS"})
    }
    title="Changer Questionnaire"
>
    <div>
        <TabletMacRounded color="primary"/>
    </div>
    <h4>Changer Questionnaire</h4>
</div> */}